import { render, staticRenderFns } from "./empty-status.vue?vue&type=template&id=6f991e0f"
import script from "./empty-status.vue?vue&type=script&lang=js"
export * from "./empty-status.vue?vue&type=script&lang=js"
import style0 from "./empty-status.vue?vue&type=style&index=0&id=6f991e0f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f991e0f')) {
      api.createRecord('6f991e0f', component.options)
    } else {
      api.reload('6f991e0f', component.options)
    }
    module.hot.accept("./empty-status.vue?vue&type=template&id=6f991e0f", function () {
      api.rerender('6f991e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/status/empty-status.vue"
export default component.exports